module.exports = __webpack_public_path__ + "70bf48b884c2c8c0dc1a2b0fd0133600.svg";